import styled from "styled-components";

export const HeaderContainer = styled.header`
  position: fixed;
  top: ${(props) => (props.$tickerVisible ? "38px" : "0")};
  width: 100%;
  background: transparent;
  backdrop-filter: blur(15px);
  -webkit-backdrop-filter: blur(15px);
  border-bottom: 1px solid var(--accent);
  z-index: 1000;
  padding: 10px 0;
  transition: all 0.3s ease;

  &.scrolled {
    background: var(--surface);
    /* box-shadow: var(--shadow-soft); */
    padding: 15px 0;
    border-bottom-color: var(--accent-light);
  }
`;

export const HeaderContainerStyled = styled.header`
  position: fixed;
  top: ${(props) => (props.$tickerVisible ? "38px" : "0")};
  width: 100%;
  background: transparent;
  backdrop-filter: blur(15px);
  -webkit-backdrop-filter: blur(15px);
  border-bottom: 1px solid var(--accent-light);
  z-index: 1000;
  padding: 10px 0;
  transition: all 0.3s ease;

  &.scrolled {
    background: var(--surface);
    /* box-shadow: var(--shadow-soft); */
    padding: 15px 0;
    border-bottom-color: var(--accent-light);
  }
`;

export const HeaderContent = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;

  @media (max-width: 990px) {
    gap: 20px;
  }
`;

export const Logo = styled.img`
  max-height: 45px;
  @media (max-width: 990px) {
    max-height: 30px;
  }
`;

export const Nav = styled.nav`
  display: flex;

  ul {
    display: flex;
    list-style: none;
    gap: 40px;
  }

  @media (max-width: 990px) {
    display: none;
  }
`;

export const NavLink = styled.a`
  text-decoration: none;
  color: var(--surface);

  font-weight: 500;
  font-size: 14px;
  text-transform: uppercase;
  letter-spacing: 1px;
  transition: all 0.3s ease;
  position: relative;
  padding: 10px 0;
  cursor: pointer;

  &::before {
    content: "";
    position: absolute;
    bottom: 0;
    left: 0;
    width: ${(props) => (props.$active ? "100%" : "0")};
    height: 2px;
    background: var(--gradient-primary);
    transition: width 0.3s ease;
  }

  &:hover::before {
    width: 100%;
  }

  &.scrolled {
    color: var(--accent);
  }
`;

export const CTAButton = styled.a`
  background: var(--gradient-primary);
  color: var(--surface);

  padding: 10px 30px;
  border: none;
  border-radius: 30px;
  font-weight: 600;
  font-family: "Source Code Pro", monospace;
  text-decoration: none;
  transition:
    color 0.3s ease,
    box-shadow 0.3s ease,
    transform 0.3s ease;

  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 10px;
  text-transform: uppercase;
  font-size: 12px;
  letter-spacing: 1px;
  box-shadow: var(--shadow-soft);

  &:hover {
    transform: translateY(-3px);
    box-shadow: var(--shadow-medium);
    background: var(--accent-dark);
    color: var(--surface);
  }
`;

export const MenuToggle = styled.div`
  display: none;
  flex-direction: column;
  cursor: pointer;
  gap: 4px;

  span {
    width: 25px;
    height: 3px;
    background: var(--accent);
    transition: 0.3s;
  }

  @media (max-width: 990px) {
    display: flex;
  }
`;

export const Container = styled.div`
  max-width: 1400px;
  margin: 0 auto;
  padding: 0 20px;
  height: 100%;
`;

export const CartIcon = styled.div`
  position: relative;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: transparent;
  border: 2px solid var(--accent);
  transition: all 0.3s ease;
  color: var(--surface);

  &:hover {
    background: var(--accent);
    color: var(--surface);
    border-color: var(--accent);
    transform: translateY(-2px);
    box-shadow: var(--shadow-soft);
    svg {
      color: var(--surface);
    }
  }

  svg {
    font-size: 18px;
  }

  &.scrolled {
    border: 2px solid var(--accent-light);
    color: var(--accent);
  }

  @media (max-width: 990px) {
    width: 35px;
    height: 35px;

    svg {
      font-size: 16px;
    }
  }
`;
export const CartIconStyled = styled.div`
  position: relative;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: transparent;
  border: 2px solid var(--accent-light);
  transition: all 0.3s ease;
  color: var(--accent);

  &:hover {
    background: var(--accent);
    color: var(--surface);
    border-color: var(--accent);
    transform: translateY(-2px);
    box-shadow: var(--shadow-soft);
  }

  svg {
    font-size: 18px;
  }

  @media (max-width: 990px) {
    width: 35px;
    height: 35px;

    svg {
      font-size: 16px;
    }
  }
`;

export const CartBadge = styled.span`
  position: absolute;
  top: -5px;
  right: -5px;
  background: var(--gradient-primary);
  color: var(--surface);
  border-radius: 50%;
  width: 22px;
  height: 22px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 11px;
  font-weight: 700;
  font-family: "Source Code Pro", monospace;
  border: 2px solid var(--accent);
  box-shadow: var(--shadow-soft);
  animation: ${(props) => (props.$pulse ? "pulse 0.6s ease-in-out" : "none")};

  @keyframes pulse {
    0% {
      transform: scale(1);
    }
    50% {
      transform: scale(1.2);
    }
    100% {
      transform: scale(1);
    }
  }

  &.scrolled {
    border: 2px solid var(--accent-light);
  }

  @media (max-width: 990px) {
    width: 20px;
    height: 20px;
    font-size: 10px;
  }
`;

export const HeaderActions = styled.div`
  display: flex;
  align-items: center;
  gap: 15px;

  @media (max-width: 990px) {
    display: none;
  }
`;
